import { render, staticRenderFns } from "./ThisPeopleState.vue?vue&type=template&id=7d47929b&scoped=true&"
import script from "./ThisPeopleState.vue?vue&type=script&lang=js&"
export * from "./ThisPeopleState.vue?vue&type=script&lang=js&"
import style0 from "./ThisPeopleState.vue?vue&type=style&index=0&id=7d47929b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d47929b",
  null
  
)

export default component.exports